import BorrowerDataChangeForm from './borrower-data-change-form';

export default BorrowerDataChangeForm;
